module.exports = __webpack_public_path__ + "static/media/mwgr2_.6bab87ad.svg";